<template>
  <BreadCrumb PageTitle="Ratio" />
  <RatioContent />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import BreadCrumb from "../../template-components/Common/BreadCrumb.vue";
import RatioContent from "../../template-components/UIElements/Ratio/RatioContent.vue";

export default defineComponent({
  name: "RatioPage",
  components: {
    BreadCrumb,
    RatioContent,
  },
});
</script>